import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { generateBreadcrumbSchema } from '../utils/seo';
import transformers from '../data/transformers.json';

interface Breadcrumb {
  label: string;
  path: string;
}

export const Breadcrumbs = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  // Don't show breadcrumbs on the home page
  if (location.pathname === '/') {
    return null;
  }

  const breadcrumbMap: Record<string, string> = {
    catalog: 'Каталог',
    transformers: 'Трансформаторы',
    kso: 'Камеры КСО',
    cable: 'Кабельная продукция',
    turnkey: 'Под ключ',
    switchgear: 'Распределительные устройства',
    ktp: 'КТПН',
    about: 'О компании',
    advantages: 'Преимущества',
    services: 'Услуги',
    projects: 'Проекты',
    contacts: 'Контакты',
    faq: 'Вопросы и ответы',
  };

  const breadcrumbs: Breadcrumb[] = pathnames.map((value, index) => {
    const path = `/${pathnames.slice(0, index + 1).join('/')}`;
    const decodedValue = decodeURIComponent(value);
    let label =
      breadcrumbMap[decodedValue] || decodedValue.charAt(0).toUpperCase() + decodedValue.slice(1);

    if (pathnames[index - 1] === 'transformers' || pathnames[index - 1] === 'ktp') {
      const product = transformers.find((t) => t.slug === decodedValue);
      if (product) {
        label = product.name;
      }
    }

    return { label, path };
  });

  const schema = generateBreadcrumbSchema(pathnames);

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
      <nav
        className="flex items-center space-x-2 text-sm text-gray-500 mb-4"
        aria-label="Breadcrumb"
      >
        <Link to="/" className="hover:text-gray-700">
          Главная
        </Link>
        {breadcrumbs.map((breadcrumb, index) => (
          <div key={breadcrumb.path} className="flex items-center">
            <span className="mx-2">/</span>
            <Link
              to={breadcrumb.path}
              className={`hover:text-gray-700 ${
                index === breadcrumbs.length - 1 ? 'text-gray-900 font-medium' : ''
              }`}
            >
              {breadcrumb.label}
            </Link>
          </div>
        ))}
      </nav>
    </>
  );
};
